// extracted by css-extract-rspack-plugin
export default {"UpsellPageContent":"CLwy5"};